import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonMessageWidget } from '@eforall/common';
import { ScheduleViewerPart } from '../../../schedule/schedule-viewer/schedule-viewer.part';
import { MentorSignUpViewerDialogDataService } from '../mentor-sign-up-viewer-dialog-data.service';

@Component({
	selector: 'mentor-sign-up-schedule-part',
	standalone: true,
	imports: [
		ScheduleViewerPart,
		CommonMessageWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './schedule.part.html',
})
export class MentorSignUpSchedulePart {

	private readonly dialogDataService = inject(MentorSignUpViewerDialogDataService);

	readonly signUpDetails = computed(() => this.dialogDataService.mentorSignUpDetails());

}